export default __webpack_public_path__ + "static/media/P40002.5116ab9b.png";